export const SITE_TITLE = process.env.REACT_APP_TITLE || 'BOC Tank Monitor'
export const API_URI = process.env.REACT_APP_API_URI

export const AWS_USER_POOL_ID = process.env.REACT_APP_AWS_USER_POOL_ID
export const AWS_CLIENT_ID = process.env.REACT_APP_AWS_CLIENT_ID
export const AWS_COGNITO_REGION = process.env.REACT_APP_AWS_COGNITO_REGION

export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY

export const DEFAULT_ZONE = 'nsw'
export const DEFAULT_COUNTRY = 'au'


export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STOREAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  apiId: process.env.REACT_APP_FIREBASE_APP_ID,
}


export const COUNTRIES = [
  {
    key: 'au',
    label: 'Australia'
  },
  {
    key: 'nz',
    label: 'New Zealand'
  },
  {
    key: 'ind',
    label: 'India'
  },
  {
    key: 'png',
    label: 'Papua New Guinea',
  },
  {
    key: 'thai',
    label: 'Thailand',
  },
  {
    key: 'phil',
    label: 'Philippines',
  },
]

export const ZONES = [
  {
    country: 'au',
    key: 'nsw',
    label: 'New South Wales',
  },
  {
    country: 'au',
    key: 'vic',
    label: 'Victoria',
  },
  {
    country: 'au',
    key: 'tas',
    label: 'Tasmania',
  },
  {
    country: 'au',
    key: 'qld',
    label: 'Queensland',
  },
  {
    country: 'au',
    key: 'sa',
    label: 'South Australia',
  },
  {
    country: 'au',
    key: 'wa',
    label: 'Western Australia',
  },
  // {
  //   country: 'nz',
  //   key: 'Not Available',
  //   label: '',
  // },

]

//status
export const STATUS = [
  {
    key: 'wip',
    label: 'Work in Progress',
    adminOnly: true,
  },
  {
    key: 'unassigned',
    label: 'Unassigned',
    adminOnly: true,
  },
  {
    key: 'nos',
    label: 'No Signal',
    adminOnly: true,
  },
  {
    key: 'inv',
    label: 'Inventory',
    adminOnly: true,
  },
  {
    key: 'op',
    label: 'Operational',
    adminOnly: false,
  },
]

export const PRODUCTS = [
  {
    key: 'argon',
    label: 'Argon',
  },
  {
    key: 'co2',
    label: 'CO2',
  },
  {
    key: 'oxygen',
    label: 'Oxygen',
  },
  {
    key: 'nitrogen',
    label: 'Nitrogen',
  },
  {
    key: 'mixed gas',
    label: 'Mixed gas',
  },
  {
    key: 'argoshield',
    label: 'Argoshield',
  },
  {
    key: 'undefined',
    label: 'Undefined',
  },
]

export const TYPES = [
  {
    key: 'bulk',
    label: 'Bulk',
  },
  {
    key: 'cryospeed',
    label: 'Cryospeed',
  },
  {
    key: 'gasmatic',
    label: 'Gasmatic',
  },
  {
    key: 'lpg',
    label: 'LPG',
  },
  {
    key: 'manifold',
    label: 'Manifold',
  },
  {
    key: 'manifold-r',
    label: 'Manifold-R',
  },
  {
    key: 'manifold-l',
    label: 'Manifold-L',
  },
  {
    key: 'blereader',
    label: 'BLE Reader',
  },
  {
    key: 'mopeka',
    label: 'Mopeka',
  },
  {
    key: 'tracker',
    label: 'Tracker',
  },
  {
    key: 'pack',
    label: 'Pack',
  },
  {
    key: 'pallet',
    label: 'Pallet',
  },
  {
    key: 'custasset',
    label: 'Customer Asset',
  },
  {
    key: 'cylinder',
    label: 'Cylinder',
  }
]

export const TRACKERTYPES = ["tracker", "pallet", "cylinder", "custasset"];

export const MBTYPES = [
  {
    key: 'ER14505M - 3.6v AAx2 - ZZ039179',
    label: 'ER14505M - 3.6v AAx2 - ZZ039179',
  },
  {
    key: 'ER18505M - 3.6v FAT Ax2 - ZZ039471',
    label: 'ER18505M - 3.6v FAT Ax2 - ZZ039471',
  },
  {
    key: 'ER34615M - 3.6v Dx1 - ZZ039472',
    label: 'ER34615M - 3.6v Dx1 - ZZ039472',
  }
]

export const SBTYPES = [
  {
    key: '1.5v Lithium AAx8 - ZZ039310',
    label: '1.5v Lithium AAx8 - ZZ039310',
  },
  {
    key: '1.5V AA Alkaline x 8',
    label: '1.5V AA Alkaline x 8',
  }
]

//Material Ocdes and pressure
export const MATERIALCODES = [
  {
    key: 'G1006',
    label: 'G1006',
    capacity: 10,
    pressure: 2000,
    product: 'Co2'

  },
  {
    key: 'G1007',
    label: 'G1007',
    capacity: 25,
    product: 'o2'
  },
  {
    key: 'G1008',
    label: 'G1008',
    capacity: 40,
    product: 'ORGON'
  }
]

export const MOVABLETYPES = ["tracker", "pallet", "cylinder", "pack"];

//For marker pin colors according to gas type
export const PINCOLORS = new Map([
  ["argon", "#407A85"],
  ["co2", "#9A9D8C"],
  ["oxygen", "#191919"],
  ["nitrogen", "#747B84"],
  ["mixed gas", "#FFA500"],
  ["argoshield", "#800080"],
  ["undefined", "#FFFFFF"]
]);

export const GEOZONES = [
  {
    //key: '[{lat: -30.4471351, lng: 136.8690383},{lat: -30.4466078, lng: 136.8714305 }, { lat: -30.4480509, lng: 136.8718709},{ lat: -30.4485967, lng: 136.8694677},{ lat: -30.4471351, lng: 136.8690383 }]',
     key : 'ZONEA',
    label: 'ZONEA',
    customerName: 'bhp',
    location: [{lat: -30.4471351, lng: 136.8690383},{lat: -30.4466078, lng: 136.8714305 }, { lat: -30.4480509, lng: 136.8718709},{ lat: -30.4485967, lng: 136.8694677},{ lat: -30.4471351, lng: 136.8690383 }],
   
  },
  {
    key: 'ZONEB',
    label: 'ZONEB',
    customerName: 'bhp',
    location: [{lat: -34.912236, lng: 138.557860},{lat: -34.912262, lng: 138.558579 }, { lat: -34.912364, lng: 138.559184},{ lat: -34.913164, lng: 138.559265},{ lat: -34.914548, lng: 138.558660 },{ lat: -34.914589, lng: 138.557933 },{ lat: -34.912236, lng: 138.557860 }],
  } ,
  {
    key: 'ZONEC',
    label: 'ZONEC',
    customerName: 'bhp',
    location: [{lat: -30.437643, lng: 136.872343},{lat: -30.439336, lng: 136.871785 }, { lat: -30.442886, lng: 136.872396},{ lat: -30.441258, lng: 136.877202},{ lat: -30.440121, lng: 136.877020 },{ lat: -30.440047, lng: 136.875164 },{ lat: -30.437679, lng: 136.872385 }],
  } ,
  {
    key: 'ZONED',
    label: 'ZONED',
    customerName: 'bhp',
    location: [{lat: -33.770593, lng: 150.908446},{lat: -33.7706184, lng: 150.9087142 }, { lat: -33.770752, lng: 150.9089453},{ lat: -33.7710775, lng: 150.9088249},{ lat: -33.770992, lng: 150.908342 },{ lat: -33.770593, lng: 150.908446 }],
  } ,
  {
    key: 'Gas$Gear',
    label: 'Gas$Gear',
    customerName: 'alcoa',
    location: [{lat: -32.067253, lng: 115.904286},{lat: -32.067092, lng: 115.90504 }, { lat: -32.066241, lng: 115.904798},{ lat: -32.066363, lng: 115.903967},{ lat: -32.067253, lng: 115.904286 }],
  } ,

  {
    key: 'Maintenance',
    label: 'Maintenance',
    customerName: 'alcoa',
    location: [{lat: -32.067092, lng: 115.90504},{lat: -32.066919, lng: 115.906053 }, { lat: -32.066094, lng: 115.905847},{ lat: -32.066283, lng: 115.90483},{ lat: -32.067092, lng: 115.90504 }],
  } ,


  {
    key: 'Elgas',
    label: 'Elgas',
    customerName: 'alcoa',
    location: [{lat: -32.066919, lng: 115.906053},{lat: -32.066766, lng: 115.906876 }, { lat: -32.065966, lng: 115.906624},{ lat: -32.066094, lng: 115.905847},{ lat: -32.066919, lng: 115.906053 }],
  } ,

  {
    key: 'Production',
    label: 'Production',
    customerName: 'alcoa',
    location: [{lat: -32.065966, lng: 115.906624},{lat: -32.064944, lng: 115.906434 }, { lat: -32.065239, lng: 115.904782},{ lat: -32.065372, lng: 115.904617},{ lat: -32.066283, lng: 115.90483 },{ lat: -32.065966, lng: 115.906624 }],
  } 
]
